import { createAsyncThunk } from '@reduxjs/toolkit';
import { getFechaDesdeService } from '../../Services';

const createBaseAsyncMethod = (actionName: string, serviceMethod: any) => {
  return createAsyncThunk(
    actionName,
    async (_, { rejectWithValue }: any) => {
      const response = await serviceMethod();
      if (response?.data && response?.status === 200) {
        return response.data;
      } else {
        return rejectWithValue({ errorMessage: 'Error al obtener la fecha desde' });
      }
    }
  );
};

export const getFechaDesdeAsync = createBaseAsyncMethod(
  'fechaDesde/fetchGetFechaDesde',
  getFechaDesdeService()?.getFechaDesde
);
